<template>
  <div class="kompa-water-sensors-edit-view">
    <h1>{{$t('titles.edit')}}</h1>
    <loader v-if="isLoading" />

    <Kompa-edit-navigation />

    <kompa-water-sensors-form @submit="updatekompaProduct"
                v-if="isSuccessfullyLoaded"
                :model="kompaProduct.waterSensors"
                :errors="errors"
                :disabled="isSubmitting" />
  </div>
</template>

<script>
import KompaEditNavigation from '@/components/KompaEditNavigation';
import KompaWaterSensorsForm from '@/components/KompaWaterSensorsForm';
import kompaProductQuery from '@/api/queries/kompa-product.graphql';
import updateKompaProductQuery
  from '@/api/mutations/update-kompa-product.graphql';
import View from '@/mixins/View';
import Submittable from '@/mixins/Submittable';
import Loader from '@/components/Loader';
import Toast from '@/helpers/Toast';

export default {
  name: 'kompa-water-sensors-edit-view',
  mixins: [
    Submittable,
    View,
  ],
  components: {
    Loader,
    KompaWaterSensorsForm,
    KompaEditNavigation,
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    isSuccessfullyLoaded() {
      return this.isLoaded && this.kompaProduct;
    },
    breadcrumbs() {
      return [
        {
          key: 'edit',
          route: {
            name: 'edit-kompa-water-sensors',
            params: { id: this.id },
          },
          isLoading: !this.isSuccessfullyLoaded,
        },
      ];
    },
  },
  apollo: {
    kompaProduct: {
      query: kompaProductQuery,
      variables() {
        return { id: this.id };
      },
      fetchPolicy: 'network-only',
      loadingKey: 'loading',
      update({ kompaProduct }) {
        return kompaProduct;
      },
      skip() {
        return !this.isAuthenticated;
      },
    },
  },
  methods: {
    async updatekompaProduct(waterSensors) {
      const operation = await this.submitWithMutation({
        mutation: updateKompaProductQuery,
        variables: {
          id: this.id,
          kompaProduct: {
            waterSensors,
          },
        },
      });
      if (operation.isValid) {
        const name = operation.kompaProduct.name;
        const message = this.$t('toasts.updated', { name });
        Toast.success(message);
        this.$router.push({
          name: 'kompa-products',
          query: { sort: 'updatedAt,desc' },
        });
      }
    },
  },
  i18n: {
    messages: {
      de: {
        titles: {
          edit: 'Kompa Produkt bearbeiten',
        },
        toasts: {
          updated: 'Kompa Product aktualisiert: {name}',
        },
      },
    },

  },
};
</script>



// WEBPACK FOOTER //
// EditWaterSensorsView.vue?c090c504